import { render } from "./DeepStrategy.vue?vue&type=template&id=e39c4006&scoped=true"
const script = {}

import "./DeepStrategy.vue?vue&type=style&index=0&id=e39c4006&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e39c4006"]])

export default __exports__